import React, { useState } from "react";

const CourseManagement = () => {
  const [courses, setCourses] = useState([]);
  const [newCourse, setNewCourse] = useState({
    title: "",
    description: "",
    difficulty: "Easy",
    duration: "",
    dueType: "fixed",
    fixedDueDate: "",
    dynamicDays: "",
    catalog: true,
    restrictGroup: "",
    certificate: false,
    image: null,
    scorm: null,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "checkbox") {
      setNewCourse({ ...newCourse, [name]: checked });
    } else if (type === "file") {
      setNewCourse({ ...newCourse, [name]: files[0] });
    } else {
      setNewCourse({ ...newCourse, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Placeholder for real upload logic
    alert("Course saved successfully (logic to be built)");
    setCourses([...courses, newCourse]);
    setNewCourse({
      title: "",
      description: "",
      difficulty: "Easy",
      duration: "",
      dueType: "fixed",
      fixedDueDate: "",
      dynamicDays: "",
      catalog: true,
      restrictGroup: "",
      certificate: false,
      image: null,
      scorm: null,
    });
  };

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <h1 className="text-2xl font-bold">Course Management</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="title"
          value={newCourse.title}
          onChange={handleChange}
          placeholder="Course Title"
          className="w-full border rounded px-4 py-2"
          required
        />
        <textarea
          name="description"
          value={newCourse.description}
          onChange={handleChange}
          placeholder="Course Description"
          className="w-full border rounded px-4 py-2"
        />

        <div className="flex gap-4">
          <select
            name="difficulty"
            value={newCourse.difficulty}
            onChange={handleChange}
            className="border rounded px-3 py-2"
          >
            <option value="Easy">Easy</option>
            <option value="Intermediate">Intermediate</option>
            <option value="Advanced">Advanced</option>
          </select>

          <input
            type="number"
            name="duration"
            value={newCourse.duration}
            onChange={handleChange}
            placeholder="Duration (minutes)"
            className="border rounded px-4 py-2"
          />
        </div>

        <div className="space-y-2">
          <p className="font-medium">Due Date</p>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="dueType"
              value="fixed"
              checked={newCourse.dueType === "fixed"}
              onChange={handleChange}
            />
            Fixed
            {newCourse.dueType === "fixed" && (
              <input
                type="date"
                name="fixedDueDate"
                value={newCourse.fixedDueDate}
                onChange={handleChange}
                className="ml-2 border rounded px-3 py-1"
              />
            )}
          </label>

          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="dueType"
              value="dynamic"
              checked={newCourse.dueType === "dynamic"}
              onChange={handleChange}
            />
            Dynamic (days after assignment)
            {newCourse.dueType === "dynamic" && (
              <input
                type="number"
                name="dynamicDays"
                value={newCourse.dynamicDays}
                onChange={handleChange}
                className="ml-2 border rounded px-3 py-1"
              />
            )}
          </label>
        </div>

        <div className="flex items-center gap-2">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="catalog"
              checked={newCourse.catalog}
              onChange={handleChange}
            />
            List in Catalogue
          </label>

          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="certificate"
              checked={newCourse.certificate}
              onChange={handleChange}
            />
            Enable Certificate
          </label>
        </div>

        <input
          type="text"
          name="restrictGroup"
          value={newCourse.restrictGroup}
          onChange={handleChange}
          placeholder="Restrict to Group (optional)"
          className="w-full border rounded px-4 py-2"
        />

        <div className="flex flex-col gap-2">
          <label>Course Image</label>
          <input type="file" name="image" onChange={handleChange} />
        </div>

        <div className="flex flex-col gap-2">
          <label>Upload SCORM File (Rise or Storyline)</label>
          <input type="file" name="scorm" onChange={handleChange} />
        </div>

        <button
          type="submit"
          className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800"
        >
          Save Course
        </button>
      </form>
    </div>
  );
};

export default CourseManagement;
